module.exports = __webpack_public_path__ + "img/pocket_back_entry_length.4c867461.png";